// extracted by mini-css-extract-plugin
export default {"styles":"PainLocated_styles__gmccP"};